"use strict";
export const TOPAZ_PRODUCT_URLS = {
  /** Topaz Flow — the consumer layer over the Topaz Compound + USDT relay. */
  flow: "https://flow.topazdex.com",
  /** Automated vault strategies. */
  vaults: "https://vaults.topazdex.com",
  /** veTOPAZ lock marketplace — buy and sell locks at a discount to spot. */
  lockMarketplace: "https://ve.topazdex.com"
};
